<div class="shelf-talkers-general-settings-container no-select">

  <div class="widget-div">

    @if (canOverridesBeViewed) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canOverridesBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canOverridesBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Overrides</div>
          <app-display-icon
            [tooltip]="tooltips.shelfTalkersOverrideSettings"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form>
            <div class="form-column">
              <div class="form-control-div toggle-item">
                <div class="label">Auto Generate Shelf Talkers</div>
                <app-switch-ui
                  (checkedChange)="onToggleSwitch( 'logActions', $event)"
                  [ariaLabel]="'user-profile-setting-log-actions'"
                  [checked]="overrideSettings.shelfTalkersEnabled"
                  [size]="0.7">
                </app-switch-ui>
              </div>
            </div>
          </form>
        </div>
        <div actions class="widget-actions">
          @if (hasOverridesBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canOverridesBeEdited === false"
              (click)="onRevertForm( 'overrides')">
              <app-display-icon
                [colour]="canOverridesBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canOverridesBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isOverridesSubmitDisabled"
              (click)="onSubmitForm('overrides')">
              <app-display-icon
                [colour]="isOverridesSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  <div class="ups-container-action-bar widget-actions">
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save All
      </button>
  </div>

</div>
